// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"brackets"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 4.5H3V19.5H6M18 4.5H21V19.5H18","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BracketsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'brackets',
    ref,
    icon: element,
  },
));

BracketsIcon.displayName = 'BracketsIcon';

export default BracketsIcon;
